import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPasswordRemovalIllustration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 128"
    fill="none"
    {...props}
  >
    <g>
      <g>
        <path
          d="M83.5 9.22705C83.5 7.4448 84.9448 6 86.7271 6H124.242L145.217 26.9758V86.2729C145.217 88.0552 143.773 89.5 141.99 89.5H86.7271C84.9448 89.5 83.5 88.0552 83.5 86.2729V9.22705Z"
          fill="#FEFEFE"
          stroke="#6FA9FF"
          strokeWidth={0.806763}
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M126.258 26.9758H145.217L124.241 6V24.9589C124.241 26.0728 125.144 26.9758 126.258 26.9758Z"
          fill="#FEFEFE"
          stroke="#6FA9FF"
          strokeWidth={0.806763}
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <rect
            x={97.2148}
            y={43.5156}
            width={32.2705}
            height={4.03382}
            rx={1.61353}
            fill="#F43F3F"
            fillOpacity={0.24}
          />
          <rect
            x={97.215}
            y={52.3906}
            width={32.2705}
            height={4.03382}
            rx={1.61353}
            fill="#F43F3F"
            fillOpacity={0.24}
          />
          <rect
            x={97.215}
            y={61.2617}
            width={32.2705}
            height={4.03382}
            rx={1.61353}
            fill="#F43F3F"
            fillOpacity={0.24}
          />
        </g>
      </g>
      <g>
        <path
          d="M71 15.6135C71 13.6178 72.6178 12 74.6135 12H116.621L140.109 35.4879V101.886C140.109 103.882 138.491 105.5 136.495 105.5H74.6135C72.6178 105.5 71 103.882 71 101.886V15.6135Z"
          fill="#FEFEFE"
          stroke="#6FA9FF"
          strokeWidth={0.903382}
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M118.879 35.4879H140.109L116.621 12V33.2295C116.621 34.4768 117.632 35.4879 118.879 35.4879Z"
          fill="#FEFEFE"
          stroke="#6FA9FF"
          strokeWidth={0.903382}
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <rect
            x={86.3574}
            y={54.0078}
            width={36.1353}
            height={4.51691}
            rx={1.80676}
            fill="#F43F3F"
            fillOpacity={0.24}
          />
          <rect
            x={86.3575}
            y={63.9453}
            width={36.1353}
            height={4.51691}
            rx={1.80676}
            fill="#F43F3F"
            fillOpacity={0.24}
          />
          <rect
            x={86.3575}
            y={73.8828}
            width={36.1353}
            height={4.51691}
            rx={1.80676}
            fill="#F43F3F"
            fillOpacity={0.24}
          />
        </g>
      </g>
      <g>
        <path
          d="M58.5 22C58.5 19.7909 60.2909 18 62.5 18H109L135 44V117.5C135 119.709 133.209 121.5 131 121.5H62.5C60.2909 121.5 58.5 119.709 58.5 117.5V22Z"
          fill="#FEFEFE"
          stroke="#6FA9FF"
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M111.5 44H135L109 18V41.5C109 42.8807 110.119 44 111.5 44Z"
          fill="#FEFEFE"
          stroke="#6FA9FF"
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g>
          <rect x={75.5} y={64.5} width={40} height={5} rx={2} fill="#C4DBFF" />
          <rect x={75.5} y={75.5} width={40} height={5} rx={2} fill="#C4DBFF" />
          <rect x={75.5} y={86.5} width={40} height={5} rx={2} fill="#C4DBFF" />
        </g>
        <g>
          <path
            d="M55 29H91C93.2091 29 95 30.7909 95 33V47.5C95 49.7091 93.2091 51.5 91 51.5H57C55.8954 51.5 55 50.6046 55 49.5V29Z"
            fill="#F43F3F"
          />
          <path d="M55 27.4559L58 27V30L55 29.3182V27.4559Z" fill="#F43F3F" />
          <path
            d="M58 26H56.326C56.1519 25.9999 55.9795 26.0386 55.8186 26.1139C55.6577 26.1892 55.5116 26.2997 55.3884 26.4389C55.2653 26.5782 55.1676 26.7435 55.101 26.9255C55.0343 27.1075 55 27.3026 55 27.4996C54.9999 27.6966 55.0341 27.8918 55.1007 28.0739C55.1673 28.256 55.265 28.4214 55.3882 28.5608C55.5113 28.7001 55.6575 28.8106 55.8184 28.886C55.9794 28.9614 56.1518 29.0001 56.326 29H58V26Z"
            fill="#6A1515"
          />
          <path
            d="M67.9 35.686C68.516 35.686 69.0573 35.812 69.524 36.064C69.9907 36.316 70.35 36.6753 70.602 37.142C70.8633 37.5993 70.994 38.1267 70.994 38.724C70.994 39.312 70.8587 39.83 70.588 40.278C70.3267 40.726 69.9533 41.076 69.468 41.328C68.992 41.5707 68.4413 41.692 67.816 41.692H65.828C65.7813 41.692 65.758 41.7153 65.758 41.762V45.332C65.758 45.3787 65.7393 45.4207 65.702 45.458C65.674 45.486 65.6367 45.5 65.59 45.5H63.952C63.9053 45.5 63.8633 45.486 63.826 45.458C63.798 45.4207 63.784 45.3787 63.784 45.332V35.854C63.784 35.8073 63.798 35.77 63.826 35.742C63.8633 35.7047 63.9053 35.686 63.952 35.686H67.9ZM67.606 40.11C68.0353 40.11 68.3807 39.9887 68.642 39.746C68.9033 39.494 69.034 39.1673 69.034 38.766C69.034 38.3553 68.9033 38.024 68.642 37.772C68.3807 37.52 68.0353 37.394 67.606 37.394H65.828C65.7813 37.394 65.758 37.4173 65.758 37.464V40.04C65.758 40.0867 65.7813 40.11 65.828 40.11H67.606ZM72.3755 45.5C72.3288 45.5 72.2868 45.486 72.2495 45.458C72.2215 45.4207 72.2075 45.3787 72.2075 45.332V35.868C72.2075 35.8213 72.2215 35.784 72.2495 35.756C72.2868 35.7187 72.3288 35.7 72.3755 35.7H75.8755C76.5755 35.7 77.1868 35.826 77.7095 36.078C78.2415 36.3207 78.6522 36.666 78.9415 37.114C79.2308 37.562 79.3755 38.08 79.3755 38.668V42.532C79.3755 43.12 79.2308 43.638 78.9415 44.086C78.6522 44.534 78.2415 44.884 77.7095 45.136C77.1868 45.3787 76.5755 45.5 75.8755 45.5H72.3755ZM74.1815 43.736C74.1815 43.7827 74.2048 43.806 74.2515 43.806H75.9455C76.3748 43.806 76.7202 43.6613 76.9815 43.372C77.2522 43.0827 77.3922 42.6953 77.4015 42.21V38.99C77.4015 38.5047 77.2662 38.1173 76.9955 37.828C76.7342 37.5387 76.3795 37.394 75.9315 37.394H74.2515C74.2048 37.394 74.1815 37.4173 74.1815 37.464V43.736ZM87.6518 37.226C87.6518 37.2727 87.6331 37.3147 87.5958 37.352C87.5678 37.38 87.5305 37.394 87.4838 37.394H82.9058C82.8591 37.394 82.8358 37.4173 82.8358 37.464V39.634C82.8358 39.6807 82.8591 39.704 82.9058 39.704H85.9158C85.9625 39.704 85.9998 39.7227 86.0278 39.76C86.0651 39.788 86.0838 39.8253 86.0838 39.872V41.23C86.0838 41.2767 86.0651 41.3187 86.0278 41.356C85.9998 41.384 85.9625 41.398 85.9158 41.398H82.9058C82.8591 41.398 82.8358 41.4213 82.8358 41.468V45.332C82.8358 45.3787 82.8171 45.4207 82.7798 45.458C82.7518 45.486 82.7145 45.5 82.6678 45.5H81.0298C80.9831 45.5 80.9411 45.486 80.9038 45.458C80.8758 45.4207 80.8618 45.3787 80.8618 45.332V35.868C80.8618 35.8213 80.8758 35.784 80.9038 35.756C80.9411 35.7187 80.9831 35.7 81.0298 35.7H87.4838C87.5305 35.7 87.5678 35.7187 87.5958 35.756C87.6331 35.784 87.6518 35.8213 87.6518 35.868V37.226Z"
            fill="white"
          />
        </g>
      </g>
      <g>
        <path
          d="M170.398 116.023L166.739 122.703C166.313 123.474 166.101 123.853 165.848 123.945C165.635 124.036 165.382 124.01 165.196 123.893C164.956 123.749 164.836 123.331 164.57 122.494L159.487 106.271C159.274 105.592 159.168 105.252 159.248 105.017C159.328 104.82 159.487 104.664 159.687 104.598C159.913 104.507 160.259 104.611 160.951 104.82L177.477 109.827C178.316 110.075 178.741 110.206 178.888 110.428C179.008 110.624 179.034 110.86 178.954 111.082C178.861 111.33 178.462 111.54 177.69 111.945L170.877 115.553C170.758 115.605 170.704 115.644 170.651 115.683C170.611 115.71 170.571 115.749 170.532 115.801C170.492 115.853 170.465 115.906 170.398 116.023Z"
          fill="#A9AABC"
        />
        <path
          d="M160.299 97.67V95.5M154.498 99.9315L152.941 98.402M154.498 111.409L152.941 112.938M166.18 99.9315L167.751 98.402M152.209 105.618H150M170.398 116.023L166.739 122.703C166.313 123.474 166.101 123.853 165.848 123.945C165.635 124.036 165.382 124.01 165.196 123.893C164.956 123.749 164.836 123.331 164.57 122.494L159.487 106.271C159.274 105.592 159.168 105.252 159.248 105.017C159.328 104.82 159.487 104.664 159.687 104.598C159.913 104.507 160.259 104.611 160.951 104.82L177.477 109.827C178.316 110.075 178.741 110.206 178.888 110.428C179.008 110.624 179.034 110.86 178.954 111.082C178.861 111.33 178.462 111.54 177.69 111.945L170.877 115.553C170.758 115.605 170.704 115.644 170.651 115.683C170.611 115.71 170.571 115.749 170.532 115.801C170.492 115.853 170.465 115.906 170.398 116.023Z"
          stroke="#A9AABC"
          strokeWidth={1.24638}
          strokeMiterlimit={22.9256}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.4472 15.7599C31.8585 16.3635 29.7963 17.5119 28.2314 19.1755C26.6665 20.8538 25.5989 23.0769 25.0285 25.8299C24.9846 26.0655 24.7652 26.2127 24.5459 26.1686C24.385 26.1244 24.268 25.9919 24.2387 25.8299C23.6684 23.0622 22.5861 20.8391 21.0212 19.1608C19.4563 17.4972 17.3795 16.3635 14.8201 15.7599C14.6007 15.7158 14.4544 15.4802 14.5129 15.2447C14.5422 15.068 14.6738 14.9355 14.8347 14.9061C17.4087 14.2877 19.5002 13.1394 21.0651 11.461C22.6153 9.79743 23.683 7.60382 24.2387 4.85077C24.2826 4.61521 24.502 4.45326 24.7214 4.51215C24.8822 4.5416 24.9992 4.68883 25.0285 4.86549C25.6135 7.61855 26.6812 9.8416 28.2461 11.5199C29.811 13.1835 31.8731 14.3172 34.4472 14.9208C34.6665 14.9649 34.7982 15.2005 34.7543 15.4213C34.725 15.598 34.5934 15.7305 34.4472 15.7599Z"
        fill="#F1CB25"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.3521 33.4348C45.1384 33.6994 44.1716 34.2027 43.4379 34.9318C42.7042 35.6673 42.2036 36.6416 41.9362 37.8482C41.9156 37.9514 41.8128 38.0159 41.7099 37.9966C41.6345 37.9772 41.5796 37.9191 41.5659 37.8482C41.2985 36.6352 40.7911 35.6609 40.0574 34.9253C39.3237 34.1962 38.35 33.6994 37.1501 33.4348C37.0472 33.4155 36.9786 33.3122 37.0061 33.209C37.0198 33.1316 37.0815 33.0735 37.1569 33.0606C38.3637 32.7896 39.3443 32.2863 40.078 31.5508C40.8048 30.8217 41.3054 29.8603 41.5659 28.6537C41.5865 28.5505 41.6894 28.4795 41.7922 28.5053C41.8676 28.5182 41.9225 28.5828 41.9362 28.6602C42.2105 29.8668 42.711 30.841 43.4447 31.5766C44.1784 32.3057 45.1452 32.8025 46.3521 33.0671C46.4549 33.0864 46.5166 33.1897 46.4961 33.2864C46.4823 33.3639 46.4206 33.4219 46.3521 33.4348Z"
        fill="#F1CB25"
      />
      <g>
        <path
          d="M48.0629 105.626C59.6955 105.626 69.1257 96.1955 69.1257 84.5629C69.1257 72.9302 59.6955 63.5 48.0629 63.5C36.4302 63.5 27 72.9302 27 84.5629C27 96.1955 36.4302 105.626 48.0629 105.626Z"
          fill="#F43F3F"
        />
        <g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.166 73.7305C51.1575 73.7305 53.5826 76.1556 53.5826 79.1471V81.3138C55.3776 81.3138 56.8326 82.7689 56.8326 84.5638V92.1471C56.8326 93.9421 55.3776 95.3971 53.5826 95.3971H42.7493C40.9544 95.3971 39.4993 93.9421 39.4993 92.1471V84.5638C39.4993 82.7689 40.9544 81.3138 42.7493 81.3138V79.1471C42.7493 76.1556 45.1744 73.7305 48.166 73.7305ZM44.916 81.3138V79.1471C44.916 77.3522 46.371 75.8971 48.166 75.8971C49.9609 75.8971 51.416 77.3522 51.416 79.1471V81.3138H44.916ZM48.166 85.6471C47.5677 85.6471 47.0826 86.1322 47.0826 86.7305V89.9805C47.0826 90.5788 47.5677 91.0638 48.166 91.0638C48.7643 91.0638 49.2493 90.5788 49.2493 89.9805V86.7305C49.2493 86.1322 48.7643 85.6471 48.166 85.6471Z"
            fill="white"
          />
        </g>
      </g>
    </g>
  </svg>
);
export default SvgPasswordRemovalIllustration;
